import { useEffect, useState, useContext } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Input } from "design-react-kit";
import Repo from "../../Utility/Repo";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import ViewPDF from "../../Components/ViewPDF";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function CheckISEE(props) {
  const apiToken = useContext(TokenContext);
  const history = useHistory();
  const [value, setValue] = useState("");
  const [file, setFile] = useState();
  const [userData, setUserData] = useState();
  const [validation, setValidation] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isee, setIsee] = useState();

  let query = useQuery();
  let idIsee = query.get("idIsee");
  useEffect(() => {
    setLoading(false);
    if (idIsee) {
      var obj = document.createElement("object");
      obj.type = ``;
      obj.data = ``;
      obj.length = 0;
      setFile(obj);

      Repo.getIsee(apiToken, idIsee)
        .then((response) => {
          if (response.status == 200) {
            obj.type = response.data.type;
            obj.data =
              `data:${response.data.type};base64, ` + response.data.file;
            obj.length = response.data.file.length;
            setFile(obj);
            setValue(response.data.value);
            setUserData(response.data.user);
            setIsee(response.data);
          }
          setLoading(true);
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });
    }
  }, []);

  const handleDelete = () => {
    const confirmDelete = window.confirm(
      `Sei sicuro di voler eliminarel'isee selezionato?`
    );

    if (confirmDelete) {
      // Chiamata API per eliminare il record
      Repo.deleteIsee(apiToken, idIsee)
        .then((response) => {
          history.goBack();
        })
        .catch((error) => {
          Repo.handleApiError(error, setError);
        });
    }
  };

  return (
    <>
      <div>
        <h1>Visualizza ISEE</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>Visualizza i dettagli dell'ISEE</p>
        </div>

        <div className="row">
          <ViewPDF
            data={file && file.data}
            length={file && file.length}
            type={file && file.type}
          />

          <div className="col-lg-4 pl-5">
            <div className="top card-space">
              <div className="card card-bg card-big roundedCustom">
                <div className="card-body">
                  <h6>Cognome, nome e data di nascita:</h6>
                  <div className="row mb-4">
                    {userData && userData.lastName}{" "}
                    {userData && userData.firstName}{" "}
                    {userData && userData.birthDate}
                  </div>

                  <h6>Codice Fiscale:</h6>
                  <div className="row mb-4">
                    {userData && userData.fiscalCode}
                  </div>
                  {isee?.dataScadenza && isee?.dataInizioValidita && (
                    <>
                      <h6>Periodo di validità:</h6>
                      <div className="row mb-4">
                        dal {isee.dataInizioValidita} a {isee.dataScadenza}
                      </div>
                    </>
                  )}

                  <h6>Anno di riferimento:</h6>
                  <div className="row mb-4">{isee && isee.year}</div>
                  {isee?.numeroProtocollo && (
                    <>
                      <h6>Protocollo ISEE:</h6>
                      <div className="row mb-4">{isee.numeroProtocollo}</div>
                    </>
                  )}

                  <h6 className="mt-3 mb-1">Valore ISEE</h6>
                  <div className="row mb-4">
                    <Input
                      id="value"
                      type="number"
                      required
                      disabled
                      value={value && value.toString()}
                      name="Valore ISEE"
                    />
                  </div>
                  <button
                    className="btn btn-danger p-2 w-100 my-1 mb-5"
                    type="button"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Elimina"
                    onClick={() => handleDelete()}
                  >
                    <svg className="icon icon-white">
                      <use href={`${iconSprite}#it-delete`} />
                    </svg>
                    Elimina
                  </button>
                  <div className="row d-flex justify-content-end">
                    <button
                      className="btn btn-outline-primary mt-3"
                      onClick={() => history.goBack()}
                    >
                      &larr; Indietro
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {!loading && <Loader></Loader>}
    </>
  );
}

export default CheckISEE;
